export const REDUCER_NAME = "contract";
export const CONTRACT_DATA = "data";
export const CONTRACT_FORM_DATA = "formData";

export const SET_IS_LOADING_CONTRACT_DATA = "SET_IS_LOADING_CONTRACT_DATA";
export const SET_IS_SAVING_CONTRACT_DATA = "SET_IS_SAVING_CONTRACT_DATA";
export const SET_CONTRACT_DATA = "SET_CONTRACT_DATA";
export const SET_CONTRACT_FORM_DATA = "SET_CONTRACT_FORM_DATA";
export const SET_CONTRACT_RESPONSE_DATA = "SET_CONTRACT_RESPONSE_DATA";
export const UPDATE_EXPENSES = "UPDATE_EXPENSES";
